<template>
  <v-card>
    <v-card-title class="headline py-2">
      Изменение {{ type === 'email' ? 'электронного адреса' : 'номера телефона' }} профиля
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <template v-if="code_sent">
          <span>Код подтверждения был отправлен на <b>{{email_phone}}</b></span>
          <v-text-field 
            label="Код подтверждения" 
            v-model="code"
            :rules="[v => !!v || 'Необходимо ввести код подтверждения']"
            required
          />
          <span v-if="count > 0">Выслать код повторно можно будет через {{ count }} сек.</span>
          <a v-else @click.prevent="sendCodeAgain">Выслать код повторно</a>
        </template>
        <v-text-field v-else 
          :label="type === 'email' ? 'Новый электронный адрес' : 'Новый номер телефона'"
          v-model="email_phone"
          :mask="type === 'phone' ? phoneMask : null"
          :rules="type === 'email' ? emailRules : phoneRules"
          :hint="type === 'email' ? 'Например, ivan@mail.ru' : 'Номер телефона в формате +7(999) 123-4567'"
          persistent-hint
          :clearable="false"
          required
        />
      </v-form>

    </v-card-text>
    
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submitData" :disabled="!valid || status.btnDisabled">{{ code_sent ? "Подтвердить" : "Отправить код" }}</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
    
  </v-card>
</template>

<script>
import apiAccount from "../../../api/"
import { isEmpty } from 'lodash'

export default {
  name : 'ChangeAuthForm',
  
  props: {
    data:{
      type: String,
      required: false,
      default: ''
    },
    type:{
      type: String,
      required: true
    },
  },
  
  data() {
    return {
      email_phone: this.data,
      phoneMask: '+7(###) ###-####',

      code: '',
      code_sent: false,

      initCountValue: 59,
      count: this.initCountValue,
      
      timer: null,

      valid: true,
      emailRules: [
        v => !!v || 'Необходимо ввести новый электронный адрес',
        v => (v !== this.data) || 'Новый электронный адрес должен отличаться от текущего',
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Неверный формат электроного адреса'
      ],
      phoneRules: [
        v => !!v || 'Необходимо ввести номер телефона',
        v => /^((\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || 'Неверный формат номер телефона'
      ],
      status:{
        btnDisabled: false,
        text: '',
        className:'success--text darken-1'
      },
    }
  },
  
  methods: {
    submitData() {
      
      
      let email_phone = ''
      if (this.$refs.form.validate()) {
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        if (!this.code_sent) {
          // If it's phone number: format it to send to server - leave only digits.
          email_phone = this.type === 'phone' 
            ? this.email_phone.replace(/\D/g,'') 
            : this.email_phone

          apiAccount.changeAuth({ email_phone }).then(response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.makeInterval()
            this.$refs.form.resetValidation()
            this.code_sent = true
          }).catch(error => {
            let errmessage = (error.response) ? error.response.data.error : 'Ошибка'
            this.status={ btnDisabled: false, text: errmessage, className:'error--text darken-1' }
          })
        } else {
          apiAccount.confirmAuth({ email_phone: this.email_phone, code: parseInt(this.code) }).then(response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            // Get profile updated data.
            let newProfileData = {}
            if (this.type === 'email') {
              newProfileData = { email: this.email_phone, confirmed_email: true }
            } else {
              newProfileData = { phone: this.email_phone, confirmed_phone: true }
            }

            // Update profile data
            this.$store.commit('app/account/setProfile', newProfileData)
            this.$dmsSuccessNoty('Способ аутентификации успешно изменен')
            
            // Close this dialog.
            this.$emit('save', { type: this.type })
          }).catch(error => {
            let errmessage = (error.response) ? error.response.data.error : 'Ошибка'
            this.status={ btnDisabled: false, text: errmessage, className:'error--text darken-1' }
          })
        }

      }
    },

    makeInterval () {
      this.count = this.initCountValue

      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },

    sendCodeAgain () {
      apiAccount.resendCode({ 
        email_phone: this.email_phone,
        context: 'auth'
      }).then(response => {
        this.$refs.form.reset()
        this.makeInterval()
      }).catch(error => {
        console.warn(error)
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/account/components/Account/Forms/ChangeAuthForm.vue